import React, { Component } from 'react';
import {Form,FormGroup,Button,ButtonGroup} from 'reactstrap';
import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';

export default class SubHeader extends Component {


  render() {
    return (
        <div className="sub-header row row-padding">
        <div className="col-sm-2">
        <ButtonGroup  className="btn-group-no">
          <Button color="primary" onClick={this.props.onRadioBtnClick} className={"btn-first"} value="1" active={this.props.rSelected == 1}>Calendar View</Button>
          <Button color="primary" onClick={this.props.onRadioBtnClick} value="2" active={this.props.rSelected == 2}>Status View</Button>
        </ButtonGroup>
        
        </div>
        <div className="col-sm-7">
          <div className="row">
            <div className="col-md-3 col-sm-6" ><FormGroup><DropDown name={"group"} data={this.props.group_data} first_element={"--Select Group--"} /></FormGroup></div>
              <div className="col-md-3 col-sm-6" ><FormGroup><DropDown name={"facility"} data={this.props.facilitydata} first_element={"--Select Facility--"}/></FormGroup></div>
              <div className="col-md-3 col-sm-6" ><FormGroup><Input type={"date"} placeholder={"Periodical Name..."}/></FormGroup></div>
              <div className="col-md-3 col-sm-6" ><FormGroup><ActionButton color={"primary"} size={"md"} className="sub-header-button-right" button_name={"Apply"}/><ActionButton color={"danger"} size={"md"} button_name={"Reset"}/></FormGroup></div>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalStatus/periodical_subheader.js